function finiteScroll(value) {
  return Number.isFinite(value) ? value : 0;
}

export function readSafeRect(value) {
  try {
    const left = value?.left;
    const right = value?.right;
    const top = value?.top;
    const bottom = value?.bottom;
    if (![left, right, top, bottom].every(Number.isFinite) || right < left || bottom < top) return null;
    return { left, right, top, bottom };
  } catch {
    return null;
  }
}

export function readViewportRect(readViewport) {
  try {
    return readSafeRect(readViewport());
  } catch {
    return null;
  }
}

export function rectIntersectsViewport(rect, viewport) {
  const safeRect = readSafeRect(rect);
  const safeViewport = readSafeRect(viewport);
  return safeRect !== null
    && safeViewport !== null
    && safeRect.right >= safeViewport.left
    && safeRect.left <= safeViewport.right
    && safeRect.bottom >= safeViewport.top
    && safeRect.top <= safeViewport.bottom;
}

function readWindowScroll(window) {
  try {
    return {
      left: finiteScroll(Number.isFinite(window?.scrollX) ? window.scrollX : window?.pageXOffset),
      top: finiteScroll(Number.isFinite(window?.scrollY) ? window.scrollY : window?.pageYOffset)
    };
  } catch {
    return { left: 0, top: 0 };
  }
}

function readElementScroll(element) {
  try {
    return {
      left: finiteScroll(element?.scrollLeft),
      top: finiteScroll(element?.scrollTop)
    };
  } catch {
    return { left: 0, top: 0 };
  }
}

export function getScrollAncestors(element) {
  const ancestors = [];
  try {
    const document = element?.ownerDocument;
    let current = element?.parentElement;
    while (current && current !== document?.body && current !== document?.documentElement) {
      ancestors.push(current);
      current = current.parentElement;
    }
  } catch {}
  return ancestors;
}

export function captureScrollOrigin(window, element) {
  return {
    window: readWindowScroll(window),
    ancestors: getScrollAncestors(element).map((ancestor) => ({
      element: ancestor,
      ...readElementScroll(ancestor)
    }))
  };
}

export function translateRectByScroll(rect, origin, window) {
  try {
    const safeRect = readSafeRect(rect);
    if (!safeRect) return null;
    let deltaLeft = readWindowScroll(window).left - origin.window.left;
    let deltaTop = readWindowScroll(window).top - origin.window.top;
    for (const baseline of origin.ancestors) {
      const current = readElementScroll(baseline.element);
      deltaLeft += current.left - baseline.left;
      deltaTop += current.top - baseline.top;
    }
    return {
      left: safeRect.left - deltaLeft,
      right: safeRect.right - deltaLeft,
      top: safeRect.top - deltaTop,
      bottom: safeRect.bottom - deltaTop
    };
  } catch {
    return null;
  }
}
